import { db } from './firebase';

// User API

export const doCreateUser = (id, username, email) =>
  db.ref(`users/${id}`).set({
    username,
    email,
  });

export const onceGetUsers = () =>
  db.ref('users').once('value');

// Phones APIs
export const onceGetPhones = () =>
  db.ref('phones').once('value');

export const onceGetPhoneLocations = number =>
  db.ref(`phones/${number}`).limitToLast(30).once('value')

// Other db APIs ...



// WEBPACK FOOTER //
// ./src/firebase/db.js